module.exports = __webpack_public_path__ + "img/perfil-tarxeta.4ca550b7.png";